import React from 'react';
import { MyProfile, PrivacyPage, TermsPage } from './pages';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routesConfig } from '@src/core/routes';


const ProfileFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<MyProfile />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="update-hub" element={<Navigate to={routesConfig.updateHub} replace />} />
    </Routes>
  );
};

export default ProfileFeature;
